// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPricesForm_wrapper__Isswx"};